import { render, staticRenderFns } from "./appDanmuConsole.vue?vue&type=template&id=97aab3c4"
import script from "./appDanmuConsole.vue?vue&type=script&lang=js"
export * from "./appDanmuConsole.vue?vue&type=script&lang=js"
import style0 from "./appDanmuConsole.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports